<h3>Ask Devin</h3>

<hr>

<div class="system-chat">
    <p-card>
        <ng-template #header>
            <div style="margin-left: 20px !important; margin-top: 20px !important;">
                <h4><i class="far fa-robot"></i>&nbsp;Devin</h4>
            </div>
        </ng-template>
        <span class="">
            What can I help with?
        </span>
    </p-card>
</div>

<div *ngIf="!sending" class="user-query">

    <hr>

    <p-iftalabel class="mb-4">
        <textarea pTextarea
                  [disabled]="sending"
                  [(ngModel)]="chat"
                  id="query"
                  rows="4"
                  style="width: 100%;"></textarea>
        <label for="query">Message Devin</label>
    </p-iftalabel>

    <p-button [disabled]="sending || chat.length == 0"
              label="Send"
              (click)="sendChat()"/>
    &nbsp;
    <p-button [disabled]="sending" severity="secondary"
              label="How many cards do we have?"
              (click)="sendChat('How many cards do we have?')"/>
    &nbsp;
    <p-button [disabled]="sending" severity="secondary"
              label="What is this project about?"
              (click)="sendChat('What is this project about?')"/>
    &nbsp;
    <p-button [disabled]="sending" severity="secondary"
              label="Suggest a new idea for this project!"
              (click)="sendChat('Suggest a new idea for this project!')"/>
    &nbsp;
    <p-button [disabled]="sending" severity="secondary"
              label="What is the trickiest card on the board?"
              (click)="sendChat('What is the trickiest card on the board?')"/>

</div>

<div *ngIf="sending">

    <hr>

    <div class="user-chat">
        <p-card>
            <ng-template #header>
                <div style="margin-left: 20px !important; margin-top: 20px !important;">
                    <h4><i class="far fa-head-side"></i>&nbsp;Human</h4>
                </div>
            </ng-template>
            <span class="">
                {{ chat }}
            </span>
        </p-card>
    </div>

    <hr>

    <div *ngIf="reply == ''">
        <p-progress-spinner
                strokeWidth="4"
                fill="transparent"
                animationDuration=".5s"
                [style]="{ width: '50px', height: '50px' }"/>
    </div>

    <div *ngIf="reply != ''">

        <div class="system-response">
            <p-card>
                <ng-template #header>
                    <div style="margin-left: 20px !important; margin-top: 20px !important;">
                        <h4><i class="far fa-robot"></i>&nbsp;Devin</h4>
                    </div>
                </ng-template>
                <span [innerHTML]="reply"></span>
            </p-card>
        </div>

        <hr>

        <p-button label="Clear"
                  (click)="reset()"/>

    </div>

</div>
